import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { TypingBreadcrumb } from "../components/TypingBreadcrumb";
import { TypingExplainer } from "../components/TypingExplainer";
import { TypingMoreLinks } from "../components/TypingMoreLinks";
import { TypingTest } from "../components/TypingTest";
import { HUB_DURATION_SEC } from "../lib/variants";

export function TypingTestIndex() {
  return (
    <div className="pct-page relative min-h-screen">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-96 pct-glow" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <TypingBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.typing_hub_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.typing_hub_intro()}
          </p>
        </header>

        <TypingTest durationSec={HUB_DURATION_SEC} />

        <TypingExplainer
          howTo={m.typing_hub_howto()}
          faqs={[
            { q: m.typing_hub_faq1_q(), a: m.typing_hub_faq1_a() },
            { q: m.typing_hub_faq2_q(), a: m.typing_hub_faq2_a() },
            { q: m.typing_hub_faq3_q(), a: m.typing_hub_faq3_a() },
            { q: m.typing_hub_faq4_q(), a: m.typing_hub_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
        <TypingMoreLinks />
      </div>
    </div>
  );
}
